module.exports = __webpack_public_path__ + "static/fonts/Spoqa-Han-Sans-Bold.f6e14af.ttf";